var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { omit } from "lodash";
class VideoPluginService {
  constructor({ disableDownloadDefault }) {
    __publicField(this, "disableDownloadDefault");
    this.disableDownloadDefault = disableDownloadDefault;
  }
  createLoadingData(_, url, componentData) {
    return {
      componentData: {
        ...componentData,
        video: { src: { url } }
      },
      componentState: {
        loading: true
      }
    };
  }
  createPluginData(uploadedData, componentData) {
    const data = uploadedData.data;
    const { pathname, thumbnail: uploadedThumbnail, url, title } = data;
    const src = pathname ? { id: pathname } : { url };
    const thumbnailObject = uploadedThumbnail ? {
      thumbnail: {
        src: { id: uploadedThumbnail.pathname },
        width: uploadedThumbnail.width,
        height: uploadedThumbnail.height
      }
    } : {};
    const titleObject = title ? { title } : {};
    return {
      ...omit(componentData, ["loading"]),
      video: { src },
      ...thumbnailObject,
      ...titleObject,
      disableDownload: componentData.video?.src ? componentData.disableDownload : this.disableDownloadDefault || void 0
    };
  }
  createErrorData(error, componentData) {
    return {
      ...omit(componentData, ["loading"]),
      error
    };
  }
}
export {
  VideoPluginService
};
//# sourceMappingURL=videoPluginService.js.map
